export function getOfficialStyle(lang){ 
    let result = 'en-GB';
    switch(lang) {
    case 'en': result='en-GB'; break;
    case 'fi': result='fi-FI'; break;
    case 'sv': result='sv-SE'; break;
    default: result='en-GB';
    }
    return result;
}


